import { render, staticRenderFns } from "./stockTake.vue?vue&type=template&id=c5f38490&"
import script from "./stockTake.vue?vue&type=script&lang=js&"
export * from "./stockTake.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports